// The 3D engine the board's Studios view borrows (web/board/src/studio/
// services.ts, BabylonModules): the Babylon modules its 3D studio uses,
// deep-imported as v1's Use 3D loads them (babylonAsset3D.ts) so webpack
// keeps them in the lazy "babylon" chunk, with the glTF, OBJ and STL loaders
// registered. The board bundle never carries a 3D engine of its own.
export async function loadBoardBabylon (): Promise<Record<string, unknown>> {
	const [engine, scene, camera, hemi, dir, vector, color, loader, shots, material] = await Promise.all([
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Engines/engine'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/scene'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Cameras/arcRotateCamera'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Lights/hemisphericLight'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Lights/directionalLight'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Maths/math.vector'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Maths/math.color'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Loading/sceneLoader'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Misc/screenshotTools'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/core/Materials/standardMaterial'),
	]);
	// side effects: register the glTF, OBJ and STL loaders with SceneLoader (a second
	// list: this app's TypeScript types a Promise.all of up to ten as a tuple)
	await Promise.all([
		import(/* webpackChunkName: "babylon" */ '@babylonjs/loaders/glTF'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/loaders/OBJ'),
		import(/* webpackChunkName: "babylon" */ '@babylonjs/loaders/STL'),
	]);
	return {
		Engine: engine.Engine,
		Scene: scene.Scene,
		ArcRotateCamera: camera.ArcRotateCamera,
		HemisphericLight: hemi.HemisphericLight,
		DirectionalLight: dir.DirectionalLight,
		Vector3: vector.Vector3,
		Color3: color.Color3,
		Color4: color.Color4,
		SceneLoader: loader.SceneLoader,
		CreateScreenshotUsingRenderTarget: shots.CreateScreenshotUsingRenderTarget,
		StandardMaterial: material.StandardMaterial,
	};
}
